module.exports = __webpack_public_path__ + "static/5-5821209dc4b158ec55a8ecb1a34cc7f6.jpg";